export class MockDataProvider {
    constructor() {
        this._store = new Map();
    }
    async get(key) {
        const value = this._store.get(key);
        return value !== undefined ? value : null;
    }
    async set(key, value) {
        this._store.set(key, value);
    }
    async delete(key) {
        this._store.delete(key);
    }
    reset() {
        this._store.clear();
    }
}
